<template>
  <div class="eating-days-selector">
    <p class="eating-days-selector__title">
      Сколько питаться
    </p>
    <div class="eating-days-selector__buttons">
      <EatingDayButton
        v-for="mealDay in mealDays"
        :key="mealDay.title"
        :meal-day="mealDay"
        :selected-meal-day="selectedMealDay"
        @select="selectMealDay(mealDay)"
      />
    </div>
  </div>
</template>

<script>
import EatingDayButton from '@/components/newOrderV4/EatingDaysSelector/EatingDayButton'

export default {
  name: 'EatingDaysSelector',

  components: {
    EatingDayButton,
  },

  props: {
    mealDays: {
      type: Array,
      required: true,
    },
  },

  emits: ['select'],

  data () {
    return {
      selectedMealDay: null,
    }
  },

  mounted () {
    this.selectedMealDay = this.mealDays.find((mealDay) => mealDay.isDefault) || this.mealDays[0]
    this.$emit('select', this.selectedMealDay)
  },

  methods: {
    selectMealDay (mealDay) {
      this.selectedMealDay = mealDay
      this.$emit('select', this.selectedMealDay)

      this.sendGTMMarkupEvent({
        block: 'new_order',
        element: 'duration',
        action: 'change',
      })
    },
  },
}
</script>

<style lang="scss">
.eating-days-selector {
  margin-top: 32px;
  padding: 0 16px;

  &__title {
    font-size: 20px;
    font-weight: 600;
    line-height: 24px;
    padding-bottom: 16px;
  }

  &__buttons {
    display: flex;
    justify-content: space-between;
    column-gap: 8px;
  }
}
</style>
